import { targetTimeout } from '@avalenti89/typescript-utils';
import { useCallback, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFirstMessageStack } from '../../reduxStore/selectors/messagesStack.selectors';
import {
	isCommandMessageShowTyping,
	SenderSource,
	isCommandCloseChannel,
} from '@enuan/chat__utils';
import { messagesStackSlice } from '../../reduxStore/slices';
import { IClientMessage } from '../../interfaces/IClientMessage';
import { configurationContext } from '../../contexts/configuration';
import { popMessageStack } from 'src/reduxStore/actions/actions';

/**
 * Used for pop out message from "wait" stack and add to messagesList
 **/
export const usePopStackMessage = () => {
	const { fake_typing_delay } = useContext(configurationContext);
	const firstMessage = useSelector(getFirstMessageStack);
	const dispatch = useDispatch();

	const popStackMessage = useCallback(
		(message: IClientMessage) => {
			dispatch(popMessageStack(message));
		},
		[dispatch],
	);

	const fakeTypingDelay = fake_typing_delay ?? 2000;

	useEffect(() => {
		if (firstMessage && !!firstMessage.timestamp) {
			if (
				firstMessage.sender === SenderSource.AGENT ||
				isCommandCloseChannel(firstMessage)
			) {
				if (!isCommandMessageShowTyping(firstMessage)) {
					dispatch(messagesStackSlice.actions.setAgentTypingMessage(undefined));
				}
				popStackMessage(firstMessage);
			} else {
				const sent = new Date(Date.now() + fakeTypingDelay).toISOString();
				targetTimeout(sent, () => {
					popStackMessage({
						...firstMessage,
						_meta: { ...firstMessage._meta, sent },
					});
				});
			}
		}
	}, [dispatch, firstMessage, popStackMessage, fakeTypingDelay]);
};
